// /src/pages/private/admin/organisationMembersTabs/internalApplications/internalApplicationsApi.js

import axios from 'axios';

export async function fetchInternalApplications(status = 'all') {
  const { data } = await axios.post(
    '/api/admin/organisation-members/internal-applications/list',
    { status },
    { withCredentials: true },
  );
  return data;
}

export async function approveInternalApplication(id, resolveComment = null) {
  const { data } = await axios.post(
    '/api/admin/organisation-members/internal-applications/approve',
    { id, resolveComment },
    { withCredentials: true },
  );
  return data;
}

export async function rejectInternalApplication(id, resolveComment) {
  const { data } = await axios.post(
    '/api/admin/organisation-members/internal-applications/reject',
    { id, resolveComment },
    { withCredentials: true },
  );
  return data;
}

export async function fetchInternalApplicationCourseSettings() {
  const { data } = await axios.post(
    '/api/admin/organisation-members/internal-applications/course-settings',
    {},
    { withCredentials: true },
  );
  return data;
}

export async function saveInternalApplicationCourseSettings(courseId) {
  const { data } = await axios.post(
    '/api/admin/organisation-members/internal-applications/course-settings/save',
    { courseId },
    { withCredentials: true },
  );
  return data;
}

export const ORG_POSITION_APPLICATIONS_WS_CHANNEL = 'orgPositionApplications:admin';

export async function orgPositionApplicationsWsLastSeen(lastSeenWsLogId) {
  const { data } = await axios.post(
    '/api/admin/organisation-members/internal-applications/ws-last-seen',
    typeof lastSeenWsLogId === 'undefined' ? {} : { lastSeenWsLogId },
    { withCredentials: true },
  );
  return data;
}

export async function getOrgPositionApplicationsWsDiff() {
  const { data } = await axios.post(
    '/api/admin/organisation-members/internal-applications/ws-diff',
    {},
    { withCredentials: true },
  );
  return data;
}

export async function wsResumeOrgPositionApplications(sinceSeq = 0) {
  const channel = encodeURIComponent(ORG_POSITION_APPLICATIONS_WS_CHANNEL);
  const { data } = await axios.post(
    `/api/ws-resume/${channel}`,
    { sinceSeq },
    { withCredentials: true },
  );
  return data;
}
